import * as wasm from './minimax_ttt_bg';
var heap = new Array(32);
heap.fill(undefined);
heap.push(undefined, null, true, false);
var stack_pointer = 32;

function addBorrowedObject(obj) {
  if (stack_pointer == 1) throw new Error('out of js stack');
  heap[--stack_pointer] = obj;
  return stack_pointer;
}

function getObject(idx) {
  return heap[idx];
}

var heap_next = heap.length;

function dropObject(idx) {
  if (idx < 36) return;
  heap[idx] = heap_next;
  heap_next = idx;
}

function takeObject(idx) {
  var ret = getObject(idx);
  dropObject(idx);
  return ret;
}
/**
* @param {any} js_objects
* @returns {any}
*/


export function get_next_best_board(js_objects) {
  try {
    return takeObject(wasm.get_next_best_board(addBorrowedObject(js_objects)));
  } finally {
    heap[stack_pointer++] = undefined;
  }
}
var WASM_VECTOR_LEN = 0;
var cachedTextEncoder = new TextEncoder('utf-8');
var cachegetUint8Memory = null;

function getUint8Memory() {
  if (cachegetUint8Memory === null || cachegetUint8Memory.buffer !== wasm.memory.buffer) {
    cachegetUint8Memory = new Uint8Array(wasm.memory.buffer);
  }

  return cachegetUint8Memory;
}

var passStringToWasm;

if (typeof cachedTextEncoder.encodeInto === 'function') {
  passStringToWasm = function passStringToWasm(arg) {
    var size = arg.length;

    var ptr = wasm.__wbindgen_malloc(size);

    var offset = 0;
    {
      var mem = getUint8Memory();

      for (; offset < arg.length; offset++) {
        var code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
      }
    }

    if (offset !== arg.length) {
      arg = arg.slice(offset);
      ptr = wasm.__wbindgen_realloc(ptr, size, size = offset + arg.length * 3);
      var view = getUint8Memory().subarray(ptr + offset, ptr + size);
      var ret = cachedTextEncoder.encodeInto(arg, view);
      offset += ret.written;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
  };
} else {
  passStringToWasm = function passStringToWasm(arg) {
    var size = arg.length;

    var ptr = wasm.__wbindgen_malloc(size);

    var offset = 0;
    {
      var mem = getUint8Memory();

      for (; offset < arg.length; offset++) {
        var code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
      }
    }

    if (offset !== arg.length) {
      var buf = cachedTextEncoder.encode(arg.slice(offset));
      ptr = wasm.__wbindgen_realloc(ptr, size, size = offset + buf.length);
      getUint8Memory().set(buf, ptr + offset);
      offset += buf.length;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
  };
}

var cachegetUint32Memory = null;

function getUint32Memory() {
  if (cachegetUint32Memory === null || cachegetUint32Memory.buffer !== wasm.memory.buffer) {
    cachegetUint32Memory = new Uint32Array(wasm.memory.buffer);
  }

  return cachegetUint32Memory;
}

var cachedTextDecoder = new TextDecoder('utf-8');

function getStringFromWasm(ptr, len) {
  return cachedTextDecoder.decode(getUint8Memory().subarray(ptr, ptr + len));
}

function addHeapObject(obj) {
  if (heap_next === heap.length) heap.push(heap.length + 1);
  var idx = heap_next;
  heap_next = heap[idx];
  heap[idx] = obj;
  return idx;
}

export var __wbindgen_json_serialize = function __wbindgen_json_serialize(ret, arg0) {
  var retptr = passStringToWasm(JSON.stringify(getObject(arg0)));
  var retlen = WASM_VECTOR_LEN;
  var mem = getUint32Memory();
  mem[ret / 4] = retptr;
  mem[ret / 4 + 1] = retlen;
};
export var __wbindgen_json_parse = function __wbindgen_json_parse(arg0, arg1) {
  var varg0 = getStringFromWasm(arg0, arg1);
  return addHeapObject(JSON.parse(varg0));
};